// Validation utilities for Asset Inspection
export function validateInspectionForm(fieldValues, images, existingImages, assetInspection, status) {
    const errors = {};
    const MAX_IMAGES = process.env.REACT_APP_MAX_IMAGES;
    const MIN_IMAGES = process.env.REACT_APP_MIN_IMAGES;
    
    let sectionFields = {};
    fieldValues.forEach(fv => {
        if (!sectionFields[fv.section]) sectionFields[fv.section] = [];
        sectionFields[fv.section].push(fv);
    });
    
    const draft = status === 'draft';
    Object.entries(sectionFields).forEach(([section, fields]) => {
        fields.forEach(f => {
            const needsValue = draft ? (f.isRequired && !f.value) : !f.value;
            if (needsValue) {
                if (!errors[section]) errors[section] = {};
                errors[section][f.field] = `"${f.name}" is required.`;
            }
        });
    });
    
    if (draft) {
        return {
            isValid: Object.keys(errors).length === 0,
            fieldErrors: errors
        };
    }

    let imageError = '';
    if ((images.length + existingImages.length) > MAX_IMAGES) {
        imageError = `You can only upload up to ${MAX_IMAGES} images.`;
    }
    if ((images.length + existingImages.length) < MIN_IMAGES) {
        imageError = `You have to upload a minimum of ${MIN_IMAGES} images.`;
    }

    let formErrors = {};
    if (status === "denied" && (!assetInspection.reason || assetInspection.reason === "")) {
        formErrors.reason = "Reason is required when inspection is denied.";
    }

    const hasError = Object.keys(errors).length > 0 || !!imageError || Object.keys(formErrors).length > 0;
    
    return {
        isValid: !hasError,
        fieldErrors: errors,
        imageError,
        formErrors
    };
}

export function getFailedFields(fieldValues) {
    return fieldValues.filter(f => f.value === 'fail' || f.value === 'failed');
}